import { render } from "./editHost.vue?vue&type=template&id=38490468&scoped=true"
import script from "./editHost.vue?vue&type=script&lang=js"
export * from "./editHost.vue?vue&type=script&lang=js"

import "./editHost.vue?vue&type=style&index=0&id=38490468&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38490468"],['__file',"src/views/setting/realNameAudit/editHost.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38490468"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38490468', __exports__)) {
    console.log('reload')
    api.reload('38490468', __exports__)
  }
  
  module.hot.accept("./editHost.vue?vue&type=template&id=38490468&scoped=true", () => {
    console.log('re-render')
    api.rerender('38490468', render)
  })

}


export default __exports__